export default __webpack_public_path__ + "static/media/rfbin_22.aefcd192.png";